import React, {Fragment, FunctionComponent} from "react"
import {useSelector} from "react-redux"
import {State} from '@App/state'
import {useTranslation} from "react-i18next"
import {EquipmentList} from "@App/Components/Vehicletree/EquipmentList/EquipmentList"
import {Equipment} from "@App/types"
import {Button} from "@App/Components/Funnel/Button";
import {FunnelHeader} from "@App/Components/Funnel/FunnelHeader";


export type EquipmentProps = {
    headline: string
    step: number
    maxSteps: number
    onSubmit?: (equipments?: Equipment[]) => void
}

export const Equipments: FunctionComponent<EquipmentProps> = ({headline, step, maxSteps, onSubmit}: EquipmentProps) => {

    const {t} = useTranslation()
    const equipments = useSelector((state: State) => state.orders.equipments)

    const submit = (): void => {
        onSubmit && onSubmit(equipments)
    }

    return (
        <Fragment>
            <div className="
                container bg-white
                pt-10 pb-12
                ">
                <FunnelHeader heading={headline}
                              step={step}
                              maxSteps={maxSteps}
                              subheading={t('equipment.headline')}
                              description={t('equipment.subheadline')}
                />
                <EquipmentList onNoEquipmentFound={submit}/>
                <Button title={t('equipment.submit')} onClick={submit}/>
            </div>
        </Fragment>
    );
}
